import axios from "axios"

const route = '/dashboard';

export default {
    namespaced: true,

    state: () => ({

    }),
    getters: {

    },
    mutations: {

    },
    actions: {
        /**
         *
         * @returns pega o valor do estoque no chessgestao
         */
        getStockValue() {
            return axios.get(`${route}/get_stock_value`)
        },

        /**
         * pega o valor do progresso geral avanço fisico
         */
        getPhysicalProgressPercentageGlobal() {
            return axios.get(`${route}/get_physical_progress_percentage_global`)
        },

        /**
         * pega todos os custos
         */
        getCostAll() {
            return axios.get(`helper/get_all_costs`)
        },

        /**
         * seta o custo q vai pegar o avanço fisico
         */
        setSelectedCost(context, cost) {
            return axios.post(`${route}/set_selected_cost`, cost)
        },

        /**
         * Pega do cheesgtao a ultima folha de pagamento
         */
        getManpower() {
            return axios.get(`${route}/get_manpower`)
        },

        /**
         * retorn o avnco finaceiro
         */
        getAvancoFinaceiro() {
            return axios.get(`${route}/get_progress_financial`)
        },

        /**
         * Retona o dados para a o grafico da curva ABC
         */
        getChartCurveABC() {
            return axios.get(`${route}/get_chart_curve_ABC`)
        },

        /**
         * retorn o avanço fisico
         */
        getPhysicalProgress() {
            return axios.get(`${route}/get_chart_physical_progress`)
        },

        /**
         * Retorna as depesas para o grafico de avanço Finaceiro
         */

        getFinancialProgress() {
            return axios.get(`${route}/get_chart_financial_progress`)
        },

        /**
         * Retorna as depesas para o grafico de Controle de insumo
         */
        getChartControlInput(context, { stage_id, date }) {
            return axios.get(`${route}/get_chart_control_input?stage_id=${stage_id}&date=${date}`)
        },

        /**
         * carrega os select de stages no controle de insumos
         */
        getLoadStages() {
            return axios.get("helper/get_stages_per_cost_current")
        },



    }
}


